module.exports = __webpack_public_path__ + "assets/9dccc5dc8b68579610ce5a66506b474d.mp4";